<div id="adsense_here" class="hide" style="border: dashed 1px cyan; visibility: hidden;">
    <p>adsense-layout works!</p>

    <div class="material-container" style="width: 90%">
        <div id="adsense_rightside ">
            <script type="text/javascript ">
            google_ad_client = "pub-1093220615930198 ";
            /* 120x240, created 5/16/09, Rightside-Generic */
            google_ad_slot = "5849319165 ";
            google_ad_width = 120;
            google_ad_height = 240;
        </script>
            <script type="text/javascript " src="http://pagead2.googlesyndication.com/pagead/show_ads.js "></script>
        </div>
    </div>

</div>